import { render, staticRenderFns } from "./_base-alert-modal.vue?vue&type=template&id=9dd39b4c&scoped=true&"
import script from "./_base-alert-modal.vue?vue&type=script&lang=js&"
export * from "./_base-alert-modal.vue?vue&type=script&lang=js&"
import style0 from "./_base-alert-modal.vue?vue&type=style&index=0&id=9dd39b4c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd39b4c",
  null
  
)

export default component.exports